module.exports = __webpack_public_path__ + "img/absolute-radio-70s.f7d9a899.png";